import { insideCircle } from "geolocation-utils";

import { IPlace, Iterable } from "types";

import { sortByCustomRating } from "./custom-rating";

export const filterByNeighborhood = (
  places: Iterable<IPlace>[],
  radius: number // in kms
) => {
  const radiusInMeters = radius * 1000;
  let filteredByNeighborhood: Iterable<IPlace>[] = [];

  places.forEach((item) => {
    const [lat, lng] = [item.latitude, item.longitude];
    const usedIDs = filteredByNeighborhood.map((i) => i.id);

    const neighbors = places.filter((i) => {
      return insideCircle(
        { lat: i.latitude, lng: i.longitude },
        { lat, lng },
        radiusInMeters
      );
    });

    if (neighbors.length === 0) {
      if (!usedIDs.includes(item.id)) {
        filteredByNeighborhood.push(item);
      }
    } else {
      const sorted = sortByCustomRating(neighbors);
      const mostRated = sorted[0];

      if (!usedIDs.includes(mostRated.id)) {
        filteredByNeighborhood.push(mostRated);
      }
    }
  });

  return filteredByNeighborhood;
};
